import type { Dtos, SuretyAccountId } from "@inrev/common";

export const sfaaCodesQueryKey = (params: Dtos.SfaaCode.List.Request = {}) =>
	[
		"sfaa-codes",
		params.type ?? null,
		params.subType ?? null,
		params.class ?? null,
		params.subClass ?? null,
	] as const;

export const recentlyUsedSfaaCodesForAccountQueryKey = (accountId: SuretyAccountId) =>
	["sfaa-codes", "recently-used", accountId] as const;

export const recentlyUsedSfaaCodesQueryKey = (
	accountId: SuretyAccountId,
	params: Dtos.SfaaCode.RecentlyUsed.Request,
) => [...recentlyUsedSfaaCodesForAccountQueryKey(accountId), params.suretyType] as const;
